var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      _vm._b(
        {
          attrs: {
            id: "g_id_onload",
            "data-client_id": _vm.client_id,
            "data-context": _vm.dataContext,
            "data-ux_mode": _vm.dataUxMode,
            "data-callback": "loginWithGoogle",
            "data-itp_support": _vm.itpSupport,
          },
        },
        "div",
        _vm.$attrs,
        false
      )
    ),
    _vm._v(" "),
    _c(
      "div",
      _vm._b(
        {
          staticClass: "g_id_signin",
          attrs: {
            "data-type": _vm.dataType,
            "data-shape": _vm.dataShape,
            "data-theme": _vm.dataTheme,
            "data-text": _vm.dataText,
            "data-size": _vm.dataSize,
            "data-logo_alignment": _vm.dataLogoAlignment,
            "data-width": _vm.dataWidth,
            "data-locale": _vm.convertLocale(_vm.currentLocale, "bcp47"),
          },
        },
        "div",
        _vm.$attrs,
        false
      )
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }